import "../DashboardLayout/dashboard.css";

export default function SidebarHeader() {

    return (

        <div className="sidebar-header">

            <div className="sidebar-brand">

                <div className="sidebar-brand-logo">

                    B

                </div>

                <div className="sidebar-brand-content">

                    <h1>

                        BABIGO

                    </h1>

                    <p>

                        Admin Platform

                    </p>

                </div>

            </div>

        </div>

    );

}